import {
  getWishlist,
  hasSkippedWishlistPopup,
  hasWishlistEmail,
  toggleWishlistItem,
  WISHLIST_UPDATED_EVENT,
} from './wishlistStore.ts';

/** Câble tous les boutons cœur de la page (`.product-card__action--wishlist` sur les
 * cartes produit boutique/home, `.produit__wishlist-btn` sur la fiche produit) —
 * même schéma que `initAddToCartButtons` (client/cart/cartActions.ts) : un listener
 * par bouton posé à l'init, pas de délégation, puisque les cartes sont du SSR
 * statique par page (pas d'insertion dynamique après chargement). */
export function initWishlistButtons(openPopup: (productIds: string[]) => void): void {
  const savedIds = new Set(getWishlist());

  function wire(root: HTMLElement, button: HTMLElement, productId: string): void {
    button.classList.toggle('is-active', savedIds.has(productId));

    button.addEventListener('click', () => {
      const added = toggleWishlistItem(productId);
      button.classList.toggle('is-active', added);

      if (added && !hasWishlistEmail() && !hasSkippedWishlistPopup()) {
        openPopup([productId]);
      }
    });
  }

  document.querySelectorAll<HTMLElement>('.product-card[data-product-id]').forEach((card) => {
    const button = card.querySelector<HTMLElement>('.product-card__action--wishlist');
    const productId = card.dataset.productId;
    if (button && productId) wire(card, button, productId);
  });

  document.querySelectorAll<HTMLElement>('.produit[data-product-id]').forEach((root) => {
    const button = root.querySelector<HTMLElement>('.produit__wishlist-btn');
    const productId = root.dataset.productId;
    if (button && productId) wire(root, button, productId);
  });
}

/** Tient à jour un badge de comptage (façon `initCartBadge`) si la page en a un. */
export function initWishlistBadge(): void {
  const badge = document.getElementById('wishlist-badge');
  if (!badge) return;

  function render(count: number): void {
    badge!.textContent = String(count);
    badge!.hidden = count === 0;
  }

  render(getWishlist().length);
  window.addEventListener(WISHLIST_UPDATED_EVENT, (e) => {
    render((e as CustomEvent<{ count: number }>).detail.count);
  });
}
